import { useEffect, useRef } from 'react';
import audioIcon from '../assets/audio.png';
import audioMuted from '../assets/audio-muted.png';
import './TabBar.css';
import { useState } from 'react';
import audioFile from '../assets/bg.mp3';
import ReactDropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import { ClipLoader } from 'react-spinners';

const BASE_URL = 'https://postrsvp-j3vs5nbufq-uc.a.run.app';
const POST_RSVP_PATH = '/postRSVP';

const TabBar = ({ id, pax, isSubmitted, fetchInvite, inviteType }) => {
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [bottomSheetVisible, setBottomSheetVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [rsvpHolmat, setRsvpHolmat] = useState({ label: 'Enter the number of attendees', value: null });
    const [rsvpReception, setRsvpReception] = useState({ label: 'Enter the number of attendees', value: null });
    const [wish, setWish] = useState('');

    const [options, setOptions] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    async function postRSVP() {
        if (rsvpHolmat?.value === null) {
            setErrorMessage('Please enter a value for Holy Matrimony RSVP');
            return;
        }

        if (inviteType === 'holmat_reception' && rsvpReception?.value === null) {
            setErrorMessage('Please enter a value for Reception RSVP');
            return;
        }

        if (!wish) {
            setErrorMessage('Message cannot be empty');
            return;
        }

        const payload = {
            id,
            rsvp_holmat: rsvpHolmat?.value,
            rsvp_reception: rsvpReception?.value || 0,
            wish,
        };

        setIsLoading(true);

        try {
            const response = await fetch(`${BASE_URL}${POST_RSVP_PATH}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.message || 'Failed to post RSVP');
            }

            fetchInvite();
            setBottomSheetVisible(false);

            setIsLoading(false);

            return result;
        } catch (error) {
            console.error('Error posting RSVP:', error);
            setIsLoading(false);
        }
    }

    const generateOptions = (p) => {
        const opts = [{ value: 0, label: 'Will not be attending' }];
        for (let i = 1; i <= p; i++) {
            opts.push({ value: i, label: `${i} person(s) attending` });
        }
        setOptions(opts);
    };

    useEffect(() => {
        generateOptions(pax);
    }, [pax]);

    const playAudio = () => {
        audioRef.current.play();
    };

    const pauseAudio = () => {
        audioRef.current.pause();
    };

    const handleToggle = () => {
        if (audioRef.current.paused) {
            playAudio();
            setIsPlaying(true);
        } else {
            pauseAudio();
            setIsPlaying(false);
        }
    };

    const toggleBottomSheet = () => {
        if (isSubmitted) return;
        setBottomSheetVisible(!bottomSheetVisible);
    };

    return (
        <div className={'tab-bar-container ' + (bottomSheetVisible ? 'bs-visible' : 'bs-hidden')}>
            <audio ref={audioRef} src={audioFile} loop />
            <div className="tab-bar">
                {pax > 0 && (
                    <button className="tab-button rsvp-button" onClick={toggleBottomSheet}>
                        <h3 className="cDark w500">{isSubmitted ? 'RSVP Submitted' : 'RSVP'}</h3>
                    </button>
                )}
                <button className="tab-button" onClick={handleToggle}>
                    <img src={isPlaying ? audioIcon : audioMuted} alt="audio" className="audio-icon" />
                </button>
            </div>
            <div className="bottom-sheet">
                <p className="cLight">This invitation is valid for {pax} person(s)</p>
                <div className="form-container">
                    <div className="input-container">
                        <p className="cLight input-label">RSVP for Holy Matrimony</p>
                        <ReactDropdown
                            options={options}
                            className="dropdown"
                            onChange={setRsvpHolmat}
                            value={rsvpHolmat}
                        />
                    </div>

                    {inviteType === 'holmat_reception' && (
                        <div className="input-container">
                            <p className="cLight input-label">RSVP for Reception</p>
                            <ReactDropdown
                                options={options}
                                className="dropdown"
                                onChange={setRsvpReception}
                                value={rsvpReception}
                            />
                        </div>
                    )}

                    <div className="input-container">
                        <p className="cLight input-label">Message for the Groom and Bride</p>
                        <textarea
                            className="textarea cDark"
                            rows={8}
                            maxLength={500}
                            value={wish}
                            onChange={(e) => setWish(e.target.value)}
                        />
                        <p className="cLight input-label">Max 500 characters</p>
                    </div>

                    {errorMessage !== '' && <p className="cRed error-message">{errorMessage}</p>}
                    <button
                        className={'submit-button' + (isLoading ? ' loading-button' : '')}
                        onClick={postRSVP}
                        disabled={isLoading}
                    >
                        <h3 className="cLight w500">Submit RSVP</h3>
                        {isLoading && <ClipLoader color="#ede9e3" size={10} />}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TabBar;
